module.exports = __webpack_public_path__ + "static/media/rhe84gm.6c9519f7.jpg";